/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import AddEditOrganizations from "./AddEditOrganizations";
import { MdDeleteForever } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiData, getByIdApi, removeByIdApi, } from "../../Redux/organizationSlice";
import { BiEdit } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { IoSearch } from "react-icons/io5";
import sweetAlert from "../Common/sweetAlert";
import { useNavigate } from "react-router-dom";
import Loading from "../Common/Loading";
import { RxDotsHorizontal } from "react-icons/rx";
import * as XLSX from 'xlsx';
import axios from "axios";
import { IMPORT_ORGANIZATION } from "../Common/API";
import toast from "react-hot-toast";
import { formatDate } from "../Common/Common";
import Pagination from "../Common/Pagination";

const Organizations = ({
  isVisible,
  setIsVisible,
  setSidebarOpen,
  sidebarOpen,
  isDark,
  setIsDark,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const store = useSelector((state) => state.root.organization);
  const { token } = useSelector((state) => state.root.auth);
  const authToken = `Bearer ${token}`;

  const [organizationEdit, setOrganizationEdit] = useState([]);
  const [loadFist, setLoadFist] = useState(true);
  const [OrganizationModel, setOrganizationModel] = useState(false);
  const [loading, setloading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [sortedField, setSortedField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectcheck, setSelectCheck] = useState(false);
  const [AciteOption, setAciteOption] = useState(false);
  const [openActionMenuId, setOpenActionMenuId] = useState(null);

  useEffect(() => {
    const handleOutsideClick = () => setOpenActionMenuId(null);
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  useEffect(() => {
    if (loadFist) {
      setloading(true);
      dispatch(fetchApiData({}))
        .then(() => {
          setloading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setloading(false);
        });
      setLoadFist(false);
    }

  }, [loadFist, dispatch]);

  useEffect(() => {
    if (selectcheck) {
      if (selectedItems?.length === sortedAndPaginatedData?.length) {
        setSelectAllChecked(true);
      }
    }
  }, [selectcheck, selectedItems]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSort = (field) => {
    if (sortedField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortOrder("asc");
      setSortedField(field);
    }
  };

  const filteredData = Array.isArray(store?.organizationData?.data)
    ? store?.organizationData?.data?.filter((item) =>
      Object.values(item).some((value) => value && value.toString().toLowerCase().includes(searchTerm?.toLowerCase()))) : [];

  const sortData = (data, field, order) => {
    const sortedData = [...data];

    sortedData.sort((a, b) => {
      const aTrimmed = a[field]?.trim() || '';
      const bTrimmed = b[field]?.trim() || '';
      if (order === "asc") {
        return aTrimmed?.localeCompare(bTrimmed);
      }
    });
    return sortedData;
  };

  const sortedAndPaginatedData = sortData(filteredData, sortedField, sortOrder).slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handleCheckboxChange = (selectID) => {
    setSelectAllChecked(false);
    setSelectCheck(true);
    if (selectedItems?.includes(selectID)) {
      setSelectedItems(selectedItems?.filter((id) => id !== selectID));
    } else {
      setSelectedItems([...selectedItems, selectID]);
    }
  };

  const handleSelectAll = () => {
    setSelectAllChecked(!selectAllChecked);

    if (selectedItems?.length === sortedAndPaginatedData?.length) {
      setSelectedItems([]);
    } else {
      const allIds = sortedAndPaginatedData?.map(
        (items) => items?.organizationID
      );
      setSelectedItems(allIds);
    }
  };

  const editData = async (id) => {
    setOrganizationModel(true);
    const res = await dispatch(getByIdApi(id));
    if (res) {
      const data = res.payload.data;
      setOrganizationEdit(data);
    }
  };

  const handleDelete = async () => {
    try {
      const result = await sweetAlert.confirm('Are you sure?', "Are you sure you want to delete this!");

      if (result.isConfirmed) {
        dispatch(removeByIdApi(selectedItems));
        sweetAlert.success("Deleted successfully");
      }
    } catch (error) {
      console.error("Error:", error);
      sweetAlert.error("An error occurred");
    }
    setCurrentPage(1)
    setLoadFist(true);
    setSelectedItems([]);
    setSelectAllChecked(false);
  };

  const toggleModalOrganization = () => {
    setOrganizationModel(!OrganizationModel);
    setOrganizationEdit([]);
    // setLoadFist(true);
  };

  const handleExport = () => {
    const data = store?.organizationData?.data?.map(item => ({

      LabelName: item.labelName,
      OrganizationName: item.organizationName,
      Address: item.address,
      VisibleToName: item.visibleToName,
      PeopleName: '',
      DealTitle: '',
      ProjectName: '',
      LeadTitle: '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Organization");
    XLSX.writeFile(workbook, "organization.xlsx");
    setAciteOption(!AciteOption)
  };

  const uploadExcel = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('ExcelFilePath', file);

    try {
      const response = await axios.post(IMPORT_ORGANIZATION, formData, {
        headers: { Authorization: authToken, 'Content-Type': 'multipart/form-data' },
      });

      if (response.data.status === true) {
        setAciteOption(!AciteOption)
        toast.success(response?.data?.message)
      }
    } catch (error) {
      console.error('Upload error:', error);
    }
  };

  const totalOrgs = store?.organizationData?.data?.length || 0;
  const totalPeopleInOrgs = store?.organizationData?.data?.reduce((acc, org) => acc + (org?.peopleCount || 0), 0) || 0;
  const openDealsOrgs = store?.organizationData?.data?.reduce((acc, org) => acc + (org?.openDeal || 0), 0) || 0;
  const wonDealsOrgs = store?.organizationData?.data?.reduce((acc, org) => acc + (org?.wonDeal || 0), 0) || 0;

  return (
    <>
      <div className="flex flex-1">
        <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">

          {/* Page Header */}
          <div className="crm-page-header">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="crm-page-title">Company</h1>
                <ol className="crm-breadcrumb">
                  <li><a href="/Analytics">Disploy</a></li>
                  <li>/</li>
                  <li>CRM</li>
                  <li>/</li>
                  <li className="active">Company</li>
                </ol>
              </div>
              <button className="crm-new-btn" onClick={() => toggleModalOrganization()}>
                <FaPlus size={11} />
                New Company
              </button>
            </div>
          </div>

          <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">

            {/* Stat Cards */}
            <div className="crm-stats-row">
              <div className="crm-stat-card crm-card-indigo">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-indigo">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Total Companies</p>
                    <p className="stat-value">{totalOrgs}</p>
                    <p className="stat-trend-up">↑ 6% vs last month</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-blue">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-blue">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Linked People</p>
                    <p className="stat-value">{totalPeopleInOrgs}</p>
                    <p className="stat-trend-up">↑ 10% vs last month</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-orange">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-orange">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" />
                      <path d="M12 6v6l4 2" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Open Deals</p>
                    <p className="stat-value">{openDealsOrgs}</p>
                    <p className="stat-trend-up">↑ 8% vs last month</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-green">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-green">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Won Deals</p>
                    <p className="stat-value">{wonDealsOrgs}</p>
                    <p className="stat-trend-up">↑ 12% vs last month</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="crm-panel">
              <div className="flex items-center justify-end px-4 py-3 border-b border-slate-100 gap-3 flex-wrap">
                <div className="crm-search-box">
                  <IoSearch size={14} />
                  <input
                    type="text"
                    placeholder="Search organizations..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>

                {selectedItems && selectedItems.length > 0 && (
                  <button
                    className="p-2 rounded-lg text-red-500 hover:bg-red-50 transition-colors"
                    onClick={handleDelete}
                    title="Delete Selected"
                  >
                    <MdDeleteForever size={18} />
                  </button>
                )}

                <div className="relative">
                  <button
                    type="button"
                    className="p-2 hover:bg-slate-50 border border-slate-200 rounded-lg text-slate-500 hover:text-slate-800 transition-colors"
                    onClick={() => setAciteOption(!AciteOption)}
                  >
                    <RxDotsHorizontal size={16} />
                  </button>
                  {AciteOption && (
                    <div className="absolute right-0 mt-1 w-44 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 text-left">
                      {store?.organizationData?.data && store?.organizationData?.data.length > 0 && (
                        <button
                          onClick={handleExport}
                          className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                        >
                          Export file results
                        </button>
                      )}
                      <label className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors cursor-pointer block">
                        <input
                          type="file"
                          className="hidden"
                          onChange={uploadExcel}
                          accept=".xls,.xlsx"
                        />
                        Import Data
                      </label>
                    </div>
                  )}
                </div>
              </div>
              {loading && (
                <div className="h-screen"><Loading /></div>
              )}
              {!loading && (
                <>
                  <div className="relative scroll-inner">
                    <table className="crm-table">
                      <thead>
                        <tr className="text-center">
                          <th scope="col" className="w-4 p-4 text-center">
                            <label className="custom-label">
                              <div className="bg-white dark:bg-slate-600/40 border border-slate-300 dark:border-slate-600 rounded w-4 h-4 inline-block leading-4 text-center -mb-[3px]">
                                <input
                                  type="checkbox"
                                  checked={selectAllChecked}
                                  onChange={() => handleSelectAll()}
                                />
                              </div>
                            </label>
                          </th>
                          <th scope="col" className="mw-200 p-4">
                            <div className="flex justify-center items-center w-full">
                              Name
                              <svg
                                className="w-3 h-3 ms-1.5 cursor-pointer"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                                onClick={() => handleSort("organizationName")}
                              >
                                <path
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Zm-6.852 0 3.426 5.05-3.426-5.05Z"
                                />
                              </svg>
                            </div>
                          </th>
                          <th scope="col" className="mw-200 p-4">Label</th>
                          <th scope="col" className="mw-200 p-4">Address</th>
                          <th scope="col" className="mw-200 p-4">People</th>
                          <th scope="col" className="mw-200 p-4">Open deals</th>
                          <th scope="col" className="mw-200 p-4">Closed deals</th>
                          <th scope="col" className="mw-200 p-4">Lost deals</th>
                          <th scope="col" className="mw-200 p-4">Won deals</th>
                          <th scope="col" className="mw-200 p-4">Done activities</th>
                          <th scope="col" className="mw-200 p-4">Activities to do</th>
                          <th scope="col" className="mw-200 p-4">Total activities</th>
                          <th scope="col" className="mw-200 p-4">Next activity</th>
                          <th scope="col" className="mw-200 p-4">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedAndPaginatedData ? (
                          sortedAndPaginatedData?.length > 0 ? (
                            sortedAndPaginatedData?.map((item, index, arr) => {
                              const showUpward = index >= arr.length - 2 && arr.length > 1;
                              return (
                                <tr
                                  key={index}
                                  className="hover:bg-slate-50 transition-colors border-b border-slate-100 text-center"
                                >
                                  <td className="w-4 p-4 text-center">
                                    <label className="custom-label">
                                      <div className="bg-white dark:bg-slate-600/40 border border-slate-200 dark:border-slate-600 rounded w-4 h-4 inline-block leading-4 text-center -mb-[3px]">
                                        <input
                                          type="checkbox"
                                          checked={selectedItems.includes(
                                            item.organizationID
                                          )}
                                          onChange={() => handleCheckboxChange(item.organizationID)}
                                        />
                                      </div>
                                    </label>
                                  </td>
                                  <td
                                    className="mw-200 p-3 capitalize text-sm font-semibold text-indigo-600 hover:text-indigo-800 whitespace-nowrap text-center cursor-pointer"
                                    onClick={() => navigate(`/detailsOrganization/${item.organizationID}`)}
                                  >
                                    {item.organizationName}
                                  </td>
                                  <td className="mw-200 p-3 text-sm text-center whitespace-nowrap">
                                    <span
                                      className="text-xs font-semibold px-2.5 py-0.5 rounded-full"
                                      style={{ backgroundColor: item?.color + '20', color: item?.color }}
                                    >
                                      {item?.labelName}
                                    </span>
                                  </td>
                                  <td className="max-w-52 truncate p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                    {item?.address}
                                  </td>
                                  <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap font-medium">
                                    {item?.peopleCount}
                                  </td>
                                  <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap font-medium text-blue-600">
                                    {item?.openDeal}
                                  </td>
                                  <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">{item?.closedDeal}</td>
                                  <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap font-medium text-red-500">{item?.lostDeal}</td>
                                  <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap font-medium text-green-600">{item?.wonDeal}</td>
                                  <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">{item?.doneActivity}</td>
                                  <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">{item?.activitiesToDo}</td>
                                  <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">{item?.totalActivities}</td>
                                  <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                    {item?.nextActivityDate ? formatDate(item?.nextActivityDate) : ''}
                                  </td>
                                  <td className="p-3 text-center whitespace-nowrap">
                                    <div className="relative inline-block text-left">
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setOpenActionMenuId(openActionMenuId === item.organizationID ? null : item.organizationID);
                                        }}
                                        className="p-1.5 text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors"
                                      >
                                        <BsThreeDotsVertical size={16} />
                                      </button>
                                      {openActionMenuId === item.organizationID && (
                                        <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              editData(item.organizationID);
                                              setOpenActionMenuId(null);
                                            }}
                                            className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                          >
                                            <BiEdit size={14} className="text-indigo-500" />
                                            <span>Edit</span>
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="15" className="text-center py-4 text-slate-500">
                                Data not found
                              </td>
                            </tr>
                          )
                        ) : (
                          <tr>
                            <td colSpan="15" className="text-center py-4 text-slate-500 animate-pulse">
                              Loading...
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination handlePageChange={handlePageChange} currentPage={currentPage} setCurrentPage={setCurrentPage} sidebarOpen={sidebarOpen} totalPages={totalPages} length={filteredData.length} setrowsPerPage={setrowsPerPage} rowsPerPage={rowsPerPage} name='Company' />

                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {OrganizationModel && (
        <AddEditOrganizations
          toggleModalOrganization={toggleModalOrganization}
          organization={organizationEdit} setLoadFist={setLoadFist}
        />
      )}
    </>
  );
};

export default Organizations;

